var React = require('react');

function NoImageGym (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"a","fill":"#fff","key":0},React.createElement("path",{"d":"m11 0c-3.96842188 0-7.5625 3.11941667-7.5625 6.9685 0 3.8481667 3.27928906 8.4425 7.5625 15.0315 4.2832109-6.589 7.5625-11.1833333 7.5625-15.0315 0-3.84908333-3.5931328-6.9685-7.5625-6.9685zm0 9.625c-1.51891667 0-2.75-1.23108333-2.75-2.75s1.23108333-2.75 2.75-2.75c1.5189167 0 2.75 1.23108333 2.75 2.75s-1.2310833 2.75-2.75 2.75z","fill":"#fff","fillRule":"evenodd"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","key":1},[React.createElement("circle",{"cx":"19","cy":"19","fill":"#000","fillRule":"nonzero","r":"19","key":0}),React.createElement("g",{"fill":"#fff","mask":"url(#a)","opacity":".401947","transform":"translate(8.181818 8.181818)","key":1},React.createElement("path",{"d":"m0 0h22v22h-22z"}))])]);
}

NoImageGym.defaultProps = {"height":"38","viewBox":"0 0 38 38","width":"38"};

module.exports = NoImageGym;

NoImageGym.default = NoImageGym;



// WEBPACK FOOTER //
// ./src/Assets/Icons/no-image-gym.svg